export default "__VITE_ASSET__fOfqyXdp__"